import * as React from 'react'

function SvgSocialFacebookCircle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10 0 5.034-3.72 9.2-8.56 9.897V22H12c.489 0 .97-.035 1.44-.103v-7.143l2.305.12.438-2.98H13.44v-1.856c0-.782.383-1.546 1.613-1.546H16.3V6.057l-.334-.05a14.625 14.625 0 00-1.881-.143c-2.26 0-3.737 1.369-3.737 3.85v2.18H7.835v2.86h2.513v7.11A9.99 9.99 0 0012 22h-1.652v-.136C5.61 21.076 2 16.96 2 12 2 6.477 6.477 2 12 2z"
      />
    </svg>
  )
}

export default SvgSocialFacebookCircle
